import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DaisyAvatarComponent, DaisyTooltipDirective } from '@pathfinder/daisy-controls/ui';
import { RouterLinkSafeUrlPipe, TimeAgoPipe, UrlSegmentPipe } from '@lib/shared/util';
import { Router, RouterModule } from '@angular/router';
import { NotificationService } from '@lib/notification/data-access';
import { NotificationCategory, NotificationAction, NotificationModel, NotificationGroupModel } from '@lib/notification/models';
import { ToastMessageService } from '@lib/shared/data-access';
import { AuthService } from '@lib/auth/data-access';

@Component({
  selector: 'lib-notification-feature-incident-notification-template',
  standalone: true,
  imports: [
    RouterLinkSafeUrlPipe,
    CommonModule,
    RouterModule,
    TimeAgoPipe,
    UrlSegmentPipe,
    DaisyAvatarComponent,
    DaisyTooltipDirective,
  ],
  templateUrl:
    './incident-notification-template.component.html',
  styleUrl:
    './incident-notification-template.component.scss',
})
export class IncidentNotificationTemplateComponent {

  // inject
  private router = inject(Router);
  public notificationService = inject(NotificationService);
  private toastMessageService = inject(ToastMessageService);
  public authService = inject(AuthService);

  // public
  public NotificationCategoryAction = NotificationAction;
  public NotificationCategory = NotificationCategory;
  public isExpanded = false;
  @Input() groupedNotification!: NotificationGroupModel;
  // private

  // accessibility only --start--
  public onHandleNotificationsKeyDown(notifications: NotificationModel[] | NotificationModel, event: KeyboardEvent) {
    if (event.key === 'Enter') {
      // Check if notifications is a single object and wrap it in an array if necessary
      const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];
      this.onNavigateToReviewClick(notificationsArray[0]);  // Navigate using the parent group notification or individual notification
      this.onMarkNotificationsReadStatusesClick(notificationsArray, true);
    }
  }
  // accessibility only --end--
  public onNavigateToIncidentClick(notifications: NotificationModel[] | NotificationModel, incidentReportId: number) {
    this.notificationService.hideNotificationSidebar();
    this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/incidents/${incidentReportId}`);

    // Check if notifications is a single object and wrap it in an array if necessary
    const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];
    this.onMarkNotificationsReadStatusesClick(notificationsArray, true);

  }

  public onHyperLinkClick(notification: NotificationModel, $event: MouseEvent) {
    if ($event) $event.stopPropagation();

    this.onMarkNotificationsReadStatusesClick(notification, true, $event);
  }

  public onNavigateToReviewClick(notification: NotificationModel) {
    this.notificationService.hideNotificationSidebar();
    this.router.navigateByUrl(`t/${this.authService.userPrincipalComputedSignal()?.currentTenantExternalId}/reviews/${notification.relatedModule?.moduleId}`);
  }

  public onMarkNotificationsReadStatusesClick(notifications: NotificationModel[] | NotificationModel, markAsRead: boolean, event?: MouseEvent) {
    if (event) event.stopPropagation();

    // Ensure notifications is always treated as an array
    const notificationsArray = Array.isArray(notifications) ? notifications : [notifications];

    // Filter out any notifications without an id and update their read status
    const updatedNotifications = notificationsArray.filter(notification => notification.id !== undefined);

    updatedNotifications.forEach(notification => {
      notification.isRead = markAsRead;
    });

    if (updatedNotifications.length > 0) {
      this.notificationService.updateNotificationsStatus(updatedNotifications).subscribe({
        error: () => this.toastMessageService.showError("Error updating notification status.")
      });
    }
  }

  public toggleExpansion() {
    this.isExpanded = !this.isExpanded;
  }
}

